module.exports = __webpack_public_path__ + "static/media/search-nodata.8692055d.png";